<template>
<v-content class="ma-0 pa-0 pb-5 pt-3">
    <v-card>
        <v-card-title style="background-color:#0e345b; color:white">
            <h5 class="ml-2 title">REPORTE DE CUMPLIMIENTO</h5>
        </v-card-title>
        <v-card-text class="pt-2">
            <v-row>
                <v-col cols="12" lg="4">
                    <v-card>
                        <v-row class="px-5 pt-2" justify="end" align="center">
                            <v-col cols="9">
                                <h5 class="subtitle-2">Busqueda de Cumplimiento</h5>
                            </v-col>
                            <v-col cols="3" class=" text-right">
                                <v-btn @click="actualizar" color="primary" dark>
                                    <v-icon>mdi-reload</v-icon>
                                </v-btn>
                            </v-col>
                            <v-col class="pt-0" cols="12"></v-col>
                            <v-col cols="6" class="pb-0">
                                <v-combobox v-model="selAño" :items="anios" label="Año" outlined></v-combobox>
                            </v-col>
                            <v-col cols="6" class="pb-0">
                                <v-combobox v-model="selCumplimiento" :items="['Si', 'No','Revision']" label="Cumplimiento" multiple outlined></v-combobox>
                            </v-col>
                            <v-col class="pt-0" cols="12"></v-col>
                            <v-col class="py-0 " cols="12">
                                <v-combobox v-model="selPeriodo" :items="periodos" item-text="periodo" label="Periodo" multiple outlined></v-combobox>
                            </v-col>
                            <v-col class="pt-0" cols="12"></v-col>
                            <v-col class="py-0" cols="12">
                                <v-combobox v-model="selDependencia" :items="dependencias" item-text="nombreUnidad" label="Dependencia" multiple outlined></v-combobox>
                            </v-col>
                              <v-col cols="8">
                                <v-btn  :loading="downloadLoading" style="margin:0 0 20px 20px;" tile outlined color="success" @click="handleDownload">
                                     <v-icon left>mdi-pencil</v-icon> Exportar a excel
                                </v-btn>
                            </v-col>

                           
   
                        </v-row>
                    </v-card>
                </v-col>
                <v-col cols="12" lg="8">
                    <!-- <div v-for="(itemE,x) in dataFraccion" :key="x">
                        <p>{{itemE}}</p>
                    </div> -->
                    <v-card elevation="1" class="mx-1">
                        <v-simple-table style="color:#0e345b" v-slot:default dense fixed-header height="500px">
                            <template>
                                <thead>
                                    <tr>
                                        <th class="text-center">Fracción</th>
                                        <th class="text-left">Unidad</th>
                                        <th class="text-left">Periodo</th>
                                        <th class="text-left">Tipo Fraccion</th>
                                        <th class="text-center">Cumplimiento</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    <tr :v-if="true" v-for="(itemE,x) in dataFraccion" :key="x">
                                        <td class="text-center">{{itemE.numFraccion}}</td>
                                        <td class="text-left">{{itemE.nombreUnidad}}</td>
                                        <td class="text-left">{{itemE.periodo}}</td>
                                        <td class="text-left">{{itemE.tipoFraccion}}</td>

                                        <td class="text-center">
                                            <v-icon color="red" v-if="itemE.archivo === 0">mdi-close</v-icon>
                                            <v-icon color="green" v-if="itemE.archivo === 1  && itemE.estatus == 1">mdi-check</v-icon>
                                             <v-icon v-if="itemE.estatus == 3 " color="yellow" @click="modalitem(itemE)" > mdi-alert</v-icon>
                                            <!-- <v-icon md color="orange darken-2" @click="modalitem(itemE)">visibility</v-icon> -->
                                        </td>
                                         <!-- <td class="text-left">{{itemE.estatus}}</td> -->
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-card>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>


  <v-card>
        <v-card-title style="background-color:#0e345b; color:white">
            <h5 class="ml-2 title">REPORTE DE CONTEO DE VISITAS</h5>
        </v-card-title>
        <v-card-text class="pt-2">
            <v-row>
                <v-col cols="12" lg="12">
                    <v-card>
    
               <v-row>
                        <v-col cols="12" sm="3" md="4">
                          <v-menu
                            v-model="menu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-model="fInicio_visitas"
                                label="Fecha de inicio"
                                prepend-icon="event"
                                readonly
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker v-model="fInicio_visitas"   locale="mx" @input="menu = false"></v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col cols="12" sm="3" md="4">
                          <v-menu
                            v-model="menu2"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-model="ffin_visitas"
                                label="Fecha Final"
                                prepend-icon="event"
                                readonly
                                v-on="on"
                              ></v-text-field>
                            </template>
                              <v-date-picker v-model="ffin_visitas"  locale="mx" @input="menu2 = false"></v-date-picker>
                          </v-menu>
                        </v-col>


                        <v-col cols="12" sm="3" md="4">       
                          <br>                                    
                          <v-btn @click="reporte('Transp_Conteo_Visitas')" color="green lighten-1" dark class="mr-3">
                              <v-icon>mdi-file-excel</v-icon> Visitas General
                          </v-btn>                    
                                         
                     
                          <v-btn @click="reporte('Transp_Conteo_Visitas_Fraccion')" color="green lighten-1" dark>
                              <v-icon>mdi-file-excel</v-icon> Visitas Fracción
                          </v-btn>
                        </v-col>
                        <v-spacer></v-spacer>
                      </v-row>
                    </v-card>
                </v-col>
          
            </v-row>
        </v-card-text>
    </v-card>


       <!-- ///Dialog Tbl Archivos ///////////////////////// -->
        <v-dialog
          v-model="dialogarchivos"
          max-width="1100"
          hide-overlay
          transition="dialog-bottom-transition"
        >
          <v-card>
            <v-toolbar dark color="primary">
              <v-btn icon dark @click="dialogarchivos = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
               <v-toolbar-title>{{NumFraccon}}</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>

            <v-divider></v-divider>
            <v-card>
              <v-data-table
                :headers="aheaders"
                :items="adesserts"
                sort-by="calories"
                class="elevation-1"
              >
                <template v-slot:top>
                  <v-toolbar flat color="white">
                    <v-toolbar-title>Archivos</v-toolbar-title>
                    <v-divider class="mx-3" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                </template>
                <template v-slot:item.estatus="{ item }">
                  <v-btn
                    depressed
                    small
                    :color="getColor(item.estatus)"
                    dark
                    @click="modalaplica(item)"
                  >{{gettxt(item.estatus)}}</v-btn>
                </template>
                <template v-slot:item.action="{ item }">
                  <!-- <v-icon md color="red">delete_sweep</v-icon> -->
                  <v-icon md color="teal darken-2" @click="desArchivo(item)">save_alt</v-icon>
                </template>
                <template v-slot:no-data>
                  <v-btn color="primary" @click="modalitem">Reset</v-btn>
                </template>
              </v-data-table>
            </v-card>
            <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
          </v-card>
        </v-dialog>
        <!-- ///////////////////Termina dialog tabl Archivos/////////////////////////// -->
</v-content>
</template>

<script>
import axios from 'axios';

import {
    mapGetters,
    mapState,
    mapActions,
    mapMutations
} from 'vuex';
import XLSX from "xlsx";

//let url_api = 'https://colmenac.ugto.mx/rg/Transparencia'
//let url_api = 'https://localhost:44340'
let url_api = 'https://enjambrec.ugto.mx/RG/Transparencia'

export default {
    // components: {
    //     GraficaGasto: () => import('./GraficaGasto')
    // },

    created() {
        this.obtenerPeriodo()
        this.obtenerDependencia()

        this.obtenerFraccionArchivo().then(() => {

            let today = new Date();
            let year = today.getFullYear();

            for (let i = year; i >= 2018; i--) {
                this.anios.push(year)
                year--

            }

        })

    },

    data() {
        return ({
             downloadLoading: false,
            NumFraccon:"",
            dataFraccion: [],
            dialogarchivos: false,
            selAño: 2020,
            selPeriodo: [],
            selCumplimiento: [],
            selDependencia: [],
            adesserts: [],
            fInicio_visitas: new Date().toISOString().substr(0, 10),
            ffin_visitas: new Date().toISOString().substr(0, 10),
            menu: false,
            menu2: false,

           
            anios: [],
            periodos: [],
            dependencias: [],
            aheaders : [
            { text: "Archivo ", value: "nombreArchivo" },
            { text: "Año", value: "anio" },
            { text: "Periodo", value: "periodo" },
            { text: "Actualización", value: "fechaCreacion", sortable: true },
            { text: "Estatus", value: "estatus", sortable: true },
            { text: "Acción", value: "action", sortable: false },
          
          ],
            dataToExport: [
        {
          name: 'Jorge',
          occupation: 'Best Admin'
        },
        {
          name: 'Héctor',
          occupation: 'Worst Admin'
        },
        {
          name: 'gmq',
          occupation: ':shrug:'
        }
      ],
            

        });
    },
    computed: {

    },
    methods: {
    async reporte (nombre_reporte) {
  const url = url_api + `/reportes/ConteoVisitas?finicio=${this.fInicio_visitas}&ffin=${this.ffin_visitas}&nombre_reporte=${nombre_reporte}`

  


  const response = await axios.get(url, {
    responseType: 'arraybuffer',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/vnd.ms-excel'
    }
  })
  const url2 = window.URL.createObjectURL(
    new Blob([response.data], { type: 'application/vnd.ms-excel' })
  )
  const a = document.createElement('a')
  a.href = url2
  a.setAttribute('download',  nombre_reporte + '.xls')
  a.click()
  a.remove()
  setTimeout(() => window.URL.revokeObjectURL(url), 100)
},
        actualizar() {
            this.dataFraccion = []

            this.obtenerFraccionArchivo().then(() => {
                 console.log(this.selCumplimiento[1])

                if (this.selCumplimiento[0] === "Si" && !this.selCumplimiento[1]) {
                    let temp = [];
                    this.dataFraccion.map((e, iG) => {
                        if (e.archivo === 1  && e.estatus == 1) {
                            temp.push(e)
                        }
                    });
                    
                    console.log("temp si",temp);
                    this.dataFraccion = temp
                }

                if (this.selCumplimiento[0] === "No" && !this.selCumplimiento[1]) {
                    let temp = [];
                    this.dataFraccion.map((e, iG) => {
                        if (e.archivo === 0) {
                            temp.push(e)
                        }
                    });
                      console.log("temp no",temp);
                    this.dataFraccion = temp
                }

                  if (this.selCumplimiento[0] === "Revision" && !this.selCumplimiento[1]) {
                    let temp = [];
                    this.dataFraccion.map((e, iG) => {
                        if (e.archivo === 1 && e.estatus == 3 ) {
                            temp.push(e)
                        }
                    });
                    console.log("temp revicion",temp);
                    this.dataFraccion = temp
                }
                    if ((this.selCumplimiento[0] === "Si"|| this.selCumplimiento[0] === "No" ) && (this.selCumplimiento[1] === "No"|| this.selCumplimiento[1] === "Si" )&& !this.selCumplimiento[2]) {
                    let temp = [];
                    this.dataFraccion.map((e, iG) => {
                        if ((e.archivo === 1  && e.estatus == 1) ||e.archivo === 0) {
                            temp.push(e)
                        }
                    });
                    
                    console.log("temp si-no",temp);
                    this.dataFraccion = temp
                }
                    if ((this.selCumplimiento[0] === "Si"|| this.selCumplimiento[0] === "Revision" ) && (this.selCumplimiento[1] === "Revision"|| this.selCumplimiento[1] === "Si" )&& !this.selCumplimiento[2]) {
                    let temp = [];
                    this.dataFraccion.map((e, iG) => {
                        if ((e.archivo === 1  && e.estatus == 1) ||(e.archivo === 1 && e.estatus == 3 )) {
                            temp.push(e)
                        }
                    });
                    
                    console.log("temp si-Revision",temp);
                    this.dataFraccion = temp
                }
                      if ((this.selCumplimiento[0] === "No"|| this.selCumplimiento[0] === "Revision" ) && (this.selCumplimiento[1] === "Revision"|| this.selCumplimiento[1] === "No" )&& !this.selCumplimiento[2]) {
                    let temp = [];
                    this.dataFraccion.map((e, iG) => {
                        if (e.archivo === 0 ||(e.archivo === 1 && e.estatus == 3 )) {
                            temp.push(e)
                        }
                    });
                    
                    console.log("temp no-Revision",temp);
                    this.dataFraccion = temp
                }
            }).then(() => {

                if (this.selPeriodo[0]) {
                    let temp2 = [];
                    this.selPeriodo.map((p, iP) => {
                        this.dataFraccion.map((e, iG) => {
                            if (p.periodo === e.periodo) {
                                temp2.push(e)
                            }
                        });

                    })
                    this.dataFraccion = temp2
                }
            }).then(() => {

                if (this.selDependencia[0]) {
                    let temp3 = [];
                    this.selDependencia.map((p, iP) => {
                        console.log("dependencia", p.nombreUnidad)
                        this.dataFraccion.map((e, iG) => {
                            if (p.nombreUnidad === e.nombreUnidad) {
                                temp3.push(e)
                            }
                        });
                    })
                    this.dataFraccion = temp3
                }
            })

        },

        // ...mapActions([""]),
        async obtenerPeriodo() {
            await this.axios.get(url_api + `/CatPeriodoes?page=1&pageSize=200&IdPeriodo=0`, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.oidcStore.access_token
                    }
                })
                .then((response) => (this.periodos = response.data.data))
                .catch((error) => console.log(error));
        },
        async obtenerDependencia() {
            await this.axios.get(url_api + `/CatUnidads?page=1&pageSize=200&id_unidad=0`, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.oidcStore.access_token
                    }
                })
                .then((response) => (this.dependencias = response.data.data))
                .catch((error) => console.log(error));
        },
        async obtenerFraccionArchivo() {
             await this.axios.get(url_api + `/VwUsuarioRol/FraccionArchivo${this.selAño}`, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.oidcStore.access_token
                    }
                })
                .then((response) => (this.dataFraccion = response.data))
                .catch((error) => console.log(error));
                console.log(this.dataFraccion);
        },
     modalitem(itemE) {
      let self = this;
      this.NumFraccon = itemE.numFraccion;
        const index = this.dataFraccion.indexOf(itemE);
      console.log("modal", itemE);
        self.$store.state.services.fraccionService
          .tblArchivos(itemE.idFraccion)
          .then(r => {
            this.adesserts = r.data.map(e => {
              e.fechaCreacion = e.fechaCreacion
                .substr(0, 10)
                .split(" ")[0]
                .split("-")
                .reverse()
                .join("-");
              return e;
            });
            console.log("modalitemsadeserts", this.adesserts);
          });
              this.dialogarchivos = true;
      },
        getColor(estatus) {
      //  console.log("color aplica", aplica);
      if (estatus == 1) {
        return "green";
      } else if (estatus == 2) {
        return "red";
      } else if (estatus == 3) {
        return "orange";
      } else if (estatus == 4) {
        return "blue";
      }
    },

    gettxt(estatus) {
      //  console.log("aplica txt", aplica);
      if (estatus == 1) {
        return "Publicado";
      } else if (estatus == 2) {
        return "No activo";
      } else if (estatus == 3) {
        return "revisión";
      } else if (estatus == 4) {
        return "no aprobado";
      }
    },

   
handleDownload(){
      this.downloadLoading = true;

      const newExcel = []
      this.dataFraccion.map(e =>{
          let dataExcel = {
          fraccion: e.numFraccion,
          unidad: e.nombreUnidad,
          periodo: e.periodo,
          tipofraccion: e.tipoFraccion,
          cumplimiento: e.archivo,      
        }

        newExcel.push(dataExcel)
      });

      let dataExcelAux=[];

      newExcel.forEach(ele => {
       
          var objDExcel = {};
          objDExcel.fraccion=ele.fraccion;
          objDExcel.unidad=ele.unidad;
          objDExcel.periodo=ele.periodo;
          objDExcel.tipofraccion=ele.tipofraccion;

        if(ele.cumplimiento==0)
          objDExcel.cumplimiento="No"; 
        else
          objDExcel.cumplimiento="Si"; 

          dataExcelAux.push(objDExcel);  
        });


    console.log(newExcel);
      let data = XLSX.utils.json_to_sheet(dataExcelAux,
 {
    //  header: ["anio", "archivo", "idFraccion", "idPeriodo"],
    // cols: [{ name: "A", key: 2 }, { name: "B", key: 3 }, { name: "C", key: 4 }],
 }
)
data["A1"].v = "Fraccion"
data["B1"].v = "Unidad"
data["C1"].v = "Periodo"
data["D1"].v = "Tipo"
data["E1"].v = "cumplimiento"

 
      const workbook = XLSX.utils.book_new()
      const filename = 'UG_Cumplimiento'
      XLSX.utils.book_append_sheet(workbook, data, filename)
      XLSX.writeFile(workbook, `${filename}.xlsx`)
      this.downloadLoading = false;
}
  
    },
    mounted() {

        // console.log("store.state",this.$store.state.oidcStore.access_token)

        // .then(() => {
        //     console.log("reportesGASTOS", this.reportesGastos)

        // })
    },

}
</script>
